
import * as React from 'react';
import { observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';

const Layer = styled<any, any>('div')`
    ${propStyles};
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: transparent;
`;

Layer.defaultProps = {
    zIndex: "clicklayer"
};

interface ClickLayerProps {
    theme?: { [property: string]: string | number };
    onClick: Function;
}

const ClickLayer: React.SFC<ClickLayerProps> = (props) => <Layer {...props} />;

export default withTheme(observer(ClickLayer));


// WEBPACK FOOTER //
// ./src/Components/ClickLayer.tsx